import { useEffect, useState } from "react";

// Ein winziger Router ohne Abhängigkeit: er liest den Pfad und navigiert per History-API.
// Der Server liefert für unbekannte Nicht-API-Pfade die index.html (SPA-Fallback), daher
// funktioniert echtes Pfad-Routing (z. B. /kueche).

/** Der aktuelle Pfadname; aktualisiert sich bei Vor/Zurück und programmatischer Navigation. */
export function usePfad(): string {
  const [pfad, setPfad] = useState(() => window.location.pathname);

  useEffect(() => {
    const beiWechsel = () => setPfad(window.location.pathname);
    window.addEventListener("popstate", beiWechsel);
    window.addEventListener("ppz:navigation", beiWechsel);
    return () => {
      window.removeEventListener("popstate", beiWechsel);
      window.removeEventListener("ppz:navigation", beiWechsel);
    };
  }, []);

  return pfad;
}

/** Navigiert ohne Neuladen zu einem internen Pfad. */
export function navigiere(pfad: string): void {
  window.history.pushState({}, "", pfad);
  window.dispatchEvent(new Event("ppz:navigation"));
}
